/**
 * Automatically appends basic UTM parameters to the current URL if they do not already exist.
 *
 * @description
 * This hook checks if the URL contains an `utm_campaign` parameter. If not, it extracts
 * the referring domain from `document.referrer` and constructs default UTM parameters
 * (`utm_source`, `utm_medium`, and `utm_campaign`) based on that referrer. It then updates
 * the browser's history with the newly formed URL, avoiding a full page refresh.
 *
 * Usage example:
 * ```jsx
 * import { useAppendUtmParams } from './useAppendUtmParams';
 *
 * function MyComponent() {
 *   useAppendUtmParams();
 *
 *   return <div>My Page</div>;
 * }
 * ```
 */
import { useEffect } from 'react';

export function useAppendUtmParams() {
  useEffect(() => {
    const urlParams = window.location.search;

    // If 'utm_campaign' is not present, append default UTM parameters using the referrer.
    if (!urlParams.includes('utm_campaign')) {
      const referrer = document.referrer;
      if (referrer) {
        const utmCampaign = new URL(referrer).hostname;
        const utmSource = 'organic_referrer';
        const utmMedium = 'organic';

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.append('utm_source', utmSource);
        newUrl.searchParams.append('utm_medium', utmMedium);
        newUrl.searchParams.append('utm_campaign', utmCampaign);

        window.history.replaceState({}, '', newUrl.toString());
      }
    }
  }, []);
}



// WEBPACK FOOTER //
// ./src/views/Auth/Login/hooks/useAppendUtmParams.js